import React from 'react';
import ReactDOM from 'react-dom';
import Hammer from 'hammerjs';
import * as messages from '@radnuc/messages';

import * as query from './Query';
import { uuidToString } from './UUID';
//import { AltAttributionUtil } from './InvestigationDisplay'
type Investigation = messages.Rad.Investigation | messages.Encounter.Encounter;

export interface AttributionImageLoaderAndDisplayProps {
    attributionSummary?: messages.Contextual.SourceAttributionSummary;
    investigation?: messages.Rad.Investigation | messages.Encounter.Encounter;
    lineOverlay?: ImagePoint[];
    forceImageResize?: boolean;
}
export interface AttributionImageLoaderAndDisplayState {
    image: HTMLImageElement | null;
}


export class AttributionImageLoaderAndDisplay extends React.Component<AttributionImageLoaderAndDisplayProps,AttributionImageLoaderAndDisplayState> {
    sourceAttrImageRef: messages.Contextual.ContextImageReference | null = null;
    sourceAttrImageQueryActive: boolean = false;
    sourceAttrImage: HTMLImageElement | null = null;

    componentWillUnmount() {
        this.sourceAttrImageQueryActive = false;
        this.sourceAttrImage = null;
        this.sourceAttrImageRef = null;
    }

    componentDidUpdate(prevProps: AttributionImageLoaderAndDisplayProps){
        //Reset if investigation id has changed (different investigation)
        if (this.props.investigation !== undefined && prevProps.investigation !== undefined){
            if(uuidToString(this.props.investigation.id) !== uuidToString(prevProps.investigation.id)){
                this.sourceAttrImage = null;
                this.sourceAttrImageRef = null;
            }
        }
    }

    updateSourceAttrImage(imageRef?: messages.Contextual.ContextImageReference) {

        if(imageRef === undefined)
            return

        if (this.sourceAttrImageQueryActive)
            return

        this.sourceAttrImageQueryActive = true;

        query.queryImageData(imageRef).then(result => {
            if(this.sourceAttrImageQueryActive === false){
                return
            }

            if(this.props.attributionSummary === undefined){
                if(this.props.investigation !== undefined && !('type' in this.props.investigation)){
                    if(this.props.investigation.alternative_attributions !== null && this.props.investigation.alternative_attributions.length > 0){
                        if(uuidToString(this.props.investigation.alternative_attributions[0].image) !== uuidToString(imageRef?.id)){
                            console.log('altImageRef Mismatch')
                            this.sourceAttrImageQueryActive = false;
                            this.sourceAttrImage = null;
                            this.sourceAttrImageQueryActive = false
                            this.render();
                            return
                        }
                    }
                } else {
                    //investigation undefined and no attribution
                    this.sourceAttrImageQueryActive = false;
                    this.sourceAttrImage = null;
                    this.sourceAttrImageQueryActive = false
                    this.render();
                    return
                }
            }  else {
                //Main Attribution through attributionSummary
                if(uuidToString(this.props.attributionSummary?.source_image.id) !== uuidToString(imageRef?.id)){
                    console.log('imageRef Mismatch')
                    this.sourceAttrImageQueryActive = false;
                    this.sourceAttrImage = null;
                    this.sourceAttrImageQueryActive = false
                    this.render();
                    return
                }
            }

            //console.log('attrSummarySourceImage: '+uuidToString(this.props.attributionSummary?.source_image.id));
            console.log('sourceAttrImageRef: '+uuidToString(imageRef?.id));

            this.sourceAttrImageRef = imageRef;

            //console.log('SrcAttrImg loaded')

            let image = new Image()
            let imageData = result.image_data as unknown as Uint8Array;

            var blob = new Blob([imageData], { type: "image/jpeg" });
            var imageUrl = URL.createObjectURL(blob);
            image.src = imageUrl;

            image.onload = () => {
                this.render();
                this.sourceAttrImageQueryActive = false
            }
            this.sourceAttrImage = image;
            this.sourceAttrImageQueryActive = false;

        }).catch((reason) => {
            setTimeout(() => {
                console.log('sourceAttrImageQuery Timeout')
                this.sourceAttrImageQueryActive = false;
            }, 5000);
        })
    }

    render() {

        let source_rect:SourceRect = {rect:null,color:null};

        let this_attributionSummary_source_image: messages.Contextual.ContextImageReference | undefined = undefined;
        let this_attributionSummary_source_rect: messages.Contextual.ImageRect | null = null;

        if(this.props.investigation !== undefined && !('type' in this.props.investigation)){

            //Sort out attribution type (Normal or alternate)
            if(this.props.attributionSummary === undefined){
                if(this.props.investigation.alternative_attributions !== null && this.props.investigation.alternative_attributions.length > 0){
                    //Alternate attribution
                    const this_alternate_attribution = this.props.investigation.alternative_attributions[0];
                    if(this_alternate_attribution.image !== null){
                        this_attributionSummary_source_image = new messages.Contextual.ContextImageReference();
                        this_attributionSummary_source_image.id = this_alternate_attribution.image;
                    } else {
                        //alternate attribution image is null
                        this.sourceAttrImage = null;
                        this.sourceAttrImageRef = null;
                        this_attributionSummary_source_image = undefined;
                    }
                }
            } else {
                if(uuidToString(this.props.attributionSummary.investigation_id) === uuidToString(this.props.investigation.id)){
                    //Normal Attribution
                    this_attributionSummary_source_image = this.props.attributionSummary.source_image;
                    this_attributionSummary_source_rect = this.props.attributionSummary.source_rect;

                } else {
                    //console.log('attr inv:'+uuidToString(this.props.attributionSummary.investigation_id))
                    //console.log('disp inv:'+uuidToString(this.props.investigation.id))
                    //investigation and attribution doesn't match
                    this.sourceAttrImage = null;
                    this.sourceAttrImageRef = null;
                    this_attributionSummary_source_image = undefined;
                }
            }

            //Determine if to load data
            if(this_attributionSummary_source_image !== undefined){
                //Matching investigation ID
                if(this.sourceAttrImageRef === null){
                    //SourceAttrImage has never loaded for this
                    if(this_attributionSummary_source_image !== null){
                        this.updateSourceAttrImage(this_attributionSummary_source_image);
                    }
                } else {
                    //Image loaded previously but check if source image loaded properly
                    if(this_attributionSummary_source_image !== null){
                        if(uuidToString(this_attributionSummary_source_image.id) !== uuidToString(this.sourceAttrImageRef.id)){
                            //SourceAttrImage is different than what is loaded
                            this.updateSourceAttrImage(this_attributionSummary_source_image);
                        }
                    } else {
                        this.sourceAttrImage = null;
                        this.sourceAttrImageRef = null;
                    }
                }

                if(this_attributionSummary_source_rect !== null){
                    source_rect.rect = this_attributionSummary_source_rect;
                    if(this.props.investigation.isotopes.length > 0 && this.props.investigation.isotopes[0].name === 'NEUTRONS'){
                        source_rect.color = 'blue';
                    } else{
                        source_rect.color = 'red';
                    }
                }
            } else {
                //Source image undefined
                this.sourceAttrImage = null;
                this.sourceAttrImageRef = null;
            }
        } else {
            //Investigation is undefined
            this.sourceAttrImage = null;
            this.sourceAttrImageRef = null;
        }

        let lane_attribution_body = null;
        let loadIndicator;
        if(this.sourceAttrImageQueryActive){
            loadIndicator = <div className="loader" style={{position: 'absolute', alignSelf:'center'}}/>
        }

        if(this.props.attributionSummary !== undefined &&
            this.props.attributionSummary?.image_redacted){
            lane_attribution_body =
                <div className="primary-metric-container" style={{marginTop:'2px', marginBottom:'2px', padding: '2px',alignItems:'center', justifyContent:'center', textAlign:'center'}}>
                    Medical isotope detected.<br></br>Image removed due to privacy/PII restrictions
                </div>
        } else {
            lane_attribution_body =
                <div className="primary-metric-container" style={{height:'99%', width:'99%', marginTop:'1px', marginBottom:'1px', padding: '0px',
                                                              alignItems:'center', justifyContent:'center', backgroundColor:'black'}}>
                    {loadIndicator}
                <AttributionImageDisplay image={this.sourceAttrImage} source_rect={source_rect} enablePanZoom={false} lineOverlay={this.props.lineOverlay} forceImageResize={this.props.forceImageResize}/>
                </div>
        }
        return (
            <>
            {lane_attribution_body}
            </>
        )

    }
}

//******************************************************************************

export interface AttributionImageDisplayProps {
    image: HTMLImageElement | null;
    source_rect: SourceRect;
    enablePanZoom?: boolean;
    window?: Window | null;
    lineOverlay?: ImagePoint[];
    forceImageResize?: boolean;
}
export interface AttributionImageDisplayState { showPopout: boolean, time: Date }

type SourceRect = { rect: messages.Contextual.ImageRect|null, color: string|null};
type viewport = {x:number, y:number, width:number, height:number};
export type ImagePoint = {x: number, y: number};

export class AttributionImageDisplay extends React.Component<AttributionImageDisplayProps,AttributionImageDisplayState> {

    canvasRef: React.RefObject<HTMLCanvasElement> = React.createRef<HTMLCanvasElement>();
    canvasContainerRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();
    canvas: HTMLCanvasElement | null = null;
    source_width: number;
    source_height: number;
    source_viewport: viewport;

    mouse_down: boolean = false;
    drag_start: number[] = [ 0, 0 ];
    zoomfactor: number = 1;
    initScale: number = 1;
    endless_pan: boolean = false;
    drawn: boolean = false;
    image: HTMLImageElement|null = null;

    constructor(props: AttributionImageDisplayProps) {
        super(props)
        this.state = {
            showPopout: false,
            time: new Date(),
        }
        this.source_width = 1;//this.props.image ? this.props.image.width : 1;
        this.source_height = 1;//this.props.image ? this.props.image.height : 1;
        this.resize = this.resize.bind(this);
        this.source_viewport = {x:0,y:0, width:this.source_width, height:this.source_height};

    }

    componentDidMount() {
        if(this.props.window){
            this.props.window.addEventListener("resize", this.resize);
        } else {
            window.addEventListener("resize", this.resize);
        }
        this.canvas = this.canvasRef.current;
        this.attach_event_handlers();

        if(this.canvas !== null){
            this.resizeCanvasToDisplaySize(this.canvas);

            this.set_image_and_redraw();
        }
    }

    componentDidUpdate(prevProps: AttributionImageDisplayProps){
        if(this.props.image !== prevProps.image){
            this.set_image_and_redraw();
        }
        if(this.props.image === null){
            this.resetCanvas();
        }
        if(this.props.forceImageResize === true){
            this.resize();
        }
    }
    componentWillUnmount() {

    }


    setPopoutOpen(open: boolean) {
        this.setState({
            showPopout: open
        });
    }
    getPopout() {
        if (!this.state.showPopout) {
            if(this.props.window)
                this.props.window.focus();
            return;
        }

        return (
            <PopoutAttributionImageDisplay title='Attribution Image' image={this.props.image} source_rect={this.props.source_rect} lineOverlay={this.props.lineOverlay}
            closeWindow={() => this.setPopoutOpen(false)}/>
        );

    }
    open_hires_image() {
        if(this.props.image !== null)
            this.setPopoutOpen(true);
    }

    set_image_and_redraw(){
        if(this.props.image !== null){
            this.image = new Image()
            this.image.src = this.props.image.src;

            this.image.onload = () => {
                this.set_viewport();
                this.redraw();
            }
        } else {
            //image is null, clear it
            this.image = null;
            this.redraw();
        }

    }

    set_viewport(){
        if(this.canvasRef.current !== null && this.props.image !== null && this.canvas !== null){
            //const canvas = this.canvasRef.current;
            var source_width = this.props.image.width;
            var source_height = this.props.image.height;

            if (source_width !== this.source_width ||
                source_height !== this.source_height) {

                this.source_width = source_width;
                this.source_height = source_height;

                var source_viewport_width;
                if(this.endless_pan){
                    source_viewport_width= this.canvas.width / this.canvas.height * this.source_height
                } else {
                    source_viewport_width = this.source_width;
                }

                this.source_viewport = {
                    x : this.source_viewport.x,
                    y : this.source_viewport.y,
                    width : source_viewport_width,
                    height : this.source_height
                };
                //console.log('set_viewport source_viewport '+this.source_viewport.height+' '+this.source_viewport.width+' '+this.source_viewport.x+' '+this.source_viewport.y)
            }
        }
    }

    resize(){
        if(this.props.image !== null){
            this.resetCanvas();
            this.set_image_and_redraw();
            //this.redraw();
        }
    }

    resetCanvas(){
        if(this.canvas !== null){
            this.canvas.width = 0;
            this.canvas.height = 0;
        }
    }

    attach_event_handlers() {
        this.mouse_down = false;
        this.drag_start = [ 0, 0 ];
        this.zoomfactor = 1;
        this.initScale = 1;

        if(this.canvas === null)
            return;

        function get_coords_mouse(event: MouseEvent) {
            return [ event.pageX, event.pageY ];
        }
        function get_coords_touch(event: TouchEvent) {
            const touch = event.touches[0];
            return [ touch.pageX, touch.pageY ];
        }
        if (this.props.enablePanZoom || this.endless_pan) {
            this.canvas.addEventListener('mousedown', (event) => {
                if(this.canvas !== null){
                    this.mouse_down = true;
                    var coords = get_coords_mouse(event);
                    this.drag_start = [
                        coords[0] - this.canvas.offsetLeft,
                        coords[1] - this.canvas.offsetTop
                    ];
                }
            });
            this.canvas.addEventListener('touchstart', (event) => {
                if(this.canvas !== null){
                    this.mouse_down = true;
                    var coords = get_coords_touch(event);
                    this.drag_start = [
                        coords[0] - this.canvas.offsetLeft,
                        coords[1] - this.canvas.offsetTop
                    ];
                }
            });
            this.canvas.addEventListener('mousemove', (event) => {
                if(this.canvas !== null){
                    if (!this.mouse_down)
                        return;

                    var coords = get_coords_mouse(event);
                    var drag_end = [
                        coords[0] - this.canvas.offsetLeft,
                        coords[1] - this.canvas.offsetTop
                    ];
                    this.translate(-drag_end[0] + this.drag_start[0],
                                   -drag_end[1] + this.drag_start[1]);
                    this.drag_start = drag_end;
                }
            });
            this.canvas.addEventListener('touchmove', (event) => {
                if(this.canvas !== null){
                    if (!this.mouse_down)
                        return;

                    var coords = get_coords_touch(event);
                    var drag_end = [
                        coords[0] - this.canvas.offsetLeft,
                        coords[1] - this.canvas.offsetTop
                    ];
                    this.translate(-drag_end[0] + this.drag_start[0],
                                   -drag_end[1] + this.drag_start[1]);
                    this.drag_start = drag_end;
                }
            });

            this.canvas.addEventListener('mouseup',
                       () => { this.mouse_down = false; });
            this.canvas.addEventListener('touchend',
                      () => { this.mouse_down = false; });
        }

        var mc = new Hammer.Manager(this.canvas);

        if (this.props.enablePanZoom) {
            // Add zooming
            const zoom_increment_pinch = 0.025
            const zoom_increment_wheel = 0.1

            this.canvas.addEventListener('wheel', (event) => {
                if(this.canvas !== null){
                    if (event.deltaY / 120 > 0) {
                        this.zoom(-zoom_increment_wheel, event.pageX-this.canvas.offsetLeft, event.pageY-this.canvas.offsetTop);
                    } else {
                        this.zoom(zoom_increment_wheel, event.pageX-this.canvas.offsetLeft, event.pageY-this.canvas.offsetTop);
                    }
                }
            });

            mc.add(new Hammer.Tap({event : 'doubletap', taps : 2}));
            mc.add(new Hammer.Pinch({threshold : 0}))
                .recognizeWith(mc.get('doubletap'));
            mc.get('pinch').set({enable : true});

            mc.on('doubletap', (event) => {
                // Reset zoom to unity
                this.zoom(-(this.zoomfactor - 1), event.center.x,
                          event.center.y);
            });

            mc.on('pinch', (event) => {
                if (event.type === 'pinchstart') {
                    this.initScale = event.scale;
                }

                if (event.scale > this.initScale) {
                    this.zoom(zoom_increment_pinch, event.center.x,
                              event.center.y);
                } else if (event.scale < this.initScale) {
                    this.zoom(-zoom_increment_pinch, event.center.x,
                              event.center.y);
                }
            });

        } else {
            // No Zooming in main screen
            //Double tap for popout hires
            mc.add(new Hammer.Tap({event : 'doubletap', taps : 2}));
            mc.on('doubletap', this.open_hires_image.bind(this));

            //two-finger Long press (650ms) to open high-image
            mc.add(new Hammer.Press({event : 'press', pointers : 2, time : 650}));
            mc.on('press', this.open_hires_image.bind(this));
        }
    }

    zoom(delta:number, centerx:number, centery:number) {
        if(this.canvas !== null){
            const max_zoom_factor = 3.0;
            const min_zoom_factor = 1.0;

            this.zoomfactor += delta;
            if (this.zoomfactor < min_zoom_factor)
                this.zoomfactor = min_zoom_factor;
            if (this.zoomfactor > max_zoom_factor)
                this.zoomfactor = max_zoom_factor;

            var w_prime;
            if(this.endless_pan){
                w_prime =
                  (this.canvas.width / this.canvas.height * this.source_height) /
                  this.zoomfactor;
            } else {
                w_prime = this.source_width / this.zoomfactor;
            }
            var h_prime = this.source_height / this.zoomfactor;
            var zoomoffset_x = -(centerx / this.canvas.width) *
                               (this.source_viewport.width - w_prime);
            var zoomoffset_y = -(centery / this.canvas.height) *
                               (this.source_viewport.height - h_prime);

            this.source_viewport.height = this.source_height / this.zoomfactor;
            if(this.endless_pan){
                this.source_viewport.width =
                    (this.canvas.width / this.canvas.height * this.source_height) /
                    this.zoomfactor;
            } else {
                this.source_viewport.width = this.source_width / this.zoomfactor;
            }

            this.source_viewport.x -= zoomoffset_x;
            this.source_viewport.y -= zoomoffset_y;

            if(!this.endless_pan){
                this.limit_source_viewport();
            }

            this.redraw();
        }
    }

    translate(dx:number, dy:number) {
        if(this.canvas !== null){
            var xscale;
            var yscale;
            this.source_viewport.height = this.source_height / this.zoomfactor;
            if(this.endless_pan){
                this.source_viewport.width =
                    (this.canvas.width / this.canvas.height * this.source_height) /
                    this.zoomfactor;
                xscale = this.source_viewport.width / this.canvas.width;
            } else {
                this.source_viewport.width = this.source_width / this.zoomfactor;
                xscale = this.source_viewport.height / this.canvas.height;
            }
            yscale = this.source_viewport.height / this.canvas.height;

            this.source_viewport.x += dx * xscale;
            this.source_viewport.y += dy * yscale;

            if(!this.endless_pan){
                this.limit_source_viewport();
            }

            /*
            if (!this.fullsize_context_window_flag) {
                // TODO: fix hack to correct coordinate system
                this.context_angle.set(
                    ((this.source_viewport.x + this.source_width / 24) /
                     this.source_width) *
                    360);
            }
            */
            this.redraw();
        }
    }

    limit_source_viewport(){
        if(this.source_viewport.x < 0){
            this.source_viewport.x = 0;
        }
        if(this.source_viewport.x > this.source_width-this.source_viewport.width){
            this.source_viewport.x = this.source_width-this.source_viewport.width;
        }
    }

    resizeCanvasToDisplaySize(canvas: HTMLCanvasElement) {
        let container = this.canvasContainerRef.current;
        if(canvas === null || container === null)
            return;

        if (canvas.width !== container.clientWidth)
            canvas.width = container.clientWidth;
        if (canvas.height !== container.clientHeight)
            canvas.height = container.clientHeight;

       return false;
    }

    clear_canvas(){
        let canvas = this.canvasRef.current;
        let container = this.canvasContainerRef.current;
        if(canvas === null || container === null)
            return;

        if (canvas.width !== container.clientWidth)
            canvas.width = container.clientWidth;
        if (canvas.height !== container.clientHeight)
            canvas.height = container.clientHeight;
/*
            const width = window.getComputedStyle(container.parentNode as Element).width;
            const height = window.getComputedStyle(container.parentNode as Element).height;
            console.log('clear_canvas width:'+width)

            canvas.width = parseInt(width);
            canvas.height = parseInt(height);
*/

        const context = canvas.getContext('2d');
        if (context === null)
            return;
        //Clear previous
        context.fillStyle = '#222';
        context.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    }

    redraw() {
        let canvas = this.canvasRef.current;
        let container = this.canvasContainerRef.current;
        if(canvas === null || container === null)
            return;

        //const width = window.getComputedStyle(container.parentNode as Element).width;
        //const height = window.getComputedStyle(container.parentNode as Element).height;
        //console.log('parent width:'+width)


        if (canvas.width !== container.clientWidth)
            canvas.width = container.clientWidth;
        if (canvas.height !== container.clientHeight)
            canvas.height = container.clientHeight;

            //canvas.width = parseInt(width);
            //canvas.height = parseInt(height);

        const context = canvas.getContext('2d');
        if (context === null)
            return;

        if (this.image === null) {
            context.globalAlpha = 1;
            context.fillStyle = '#222';
            context.fillRect(0, 0, canvas.width, canvas.height);
            /*
            if (this.v2s_direction !== null) {
                this.draw_v2s();
            }
            */
            return;
        }

        //let xscale = this.source_viewport.width / canvas.width;
        let yscale = this.source_viewport.height / canvas.height;

        // Check bounds to make sure source viewport isn't outside source
        if (this.source_viewport.y < 0) {
            this.source_viewport.y += -this.source_viewport.y;
        }

        if ((this.source_viewport.height + this.source_viewport.y) / yscale <=
            canvas.height) {
            // window is bigger than the image height
            this.source_viewport.y = 0;
        } else if ((this.source_viewport.height + this.source_viewport.y) >
                   this.source_height) {
            this.source_viewport.y =
                this.source_height - this.source_height / this.zoomfactor;
        }


        if(this.endless_pan){
            context.drawImage(this.image, this.source_viewport.x,
                               this.source_viewport.y, this.source_viewport.width,
                               this.source_viewport.height, 0, 0, canvas.width,
                               canvas.height);

            if (this.source_viewport.x < 0) {
                context.drawImage(
                    this.image, this.source_viewport.x + this.source_width,
                    this.source_viewport.y, this.source_viewport.width,
                    this.source_viewport.height, 0, 0, canvas.width,
                    canvas.height);
            }

            if (this.source_viewport.x < -this.source_viewport.width)
                this.source_viewport.x += this.source_width;

            if (this.source_viewport.x + this.source_viewport.width >
                this.source_width) {
                context.drawImage(
                    this.image, this.source_viewport.x - this.source_width,
                    this.source_viewport.y, this.source_viewport.width,
                    this.source_viewport.height, 0, 0, canvas.width,
                    canvas.height);
            }

            if (this.source_viewport.x >
                this.source_width + this.source_viewport.width)
                this.source_viewport.x -= this.source_width;

        } else {
            //Single image case (Disable Endless Pan)
            let source_viewport_desired_height = this.source_viewport.height;
            let source_viewport_desired_width = this.source_viewport.width;
            let source_viewport_y = this.source_viewport.y;
            let source_viewport_x = this.source_viewport.x;

            if(canvas.clientHeight > canvas.clientWidth){
                //View is portrait
                const aspect_ratio = canvas.clientHeight / canvas.clientWidth;
                source_viewport_desired_height = aspect_ratio * this.source_viewport.width;
                source_viewport_y = this.source_viewport.y - (source_viewport_desired_height-this.source_viewport.height)/2;
            } else {
                //view is landscape
                const aspect_ratio = canvas.clientWidth / canvas.clientHeight;
                source_viewport_desired_width = aspect_ratio * this.source_viewport.height;
                source_viewport_x = this.source_viewport.x - (source_viewport_desired_width-this.source_viewport.width)/2;
            }

            //Redraw
            //Clear previous
            context.fillStyle = 'black';
            context.globalAlpha = 1;
            context.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);

            context.drawImage(this.image, source_viewport_x,
                               source_viewport_y, source_viewport_desired_width,
                               source_viewport_desired_height, 0, 0, canvas.clientWidth,
                               canvas.clientHeight);

            //console.log('redraw source_viewport '+this.source_viewport.height+' '+this.source_viewport.width+' '+this.source_viewport.x+' '+this.source_viewport.y)
            //console.log('done redraw')
        }
        if (this.props.source_rect !== undefined && this.props.source_rect.rect !== null ){
            //Attribution Rectangle
            this.draw_source_rect();
        } else {
            //Attribution Gate Overlay (if defined)
            if (this.props.lineOverlay !== undefined && this.props.lineOverlay !== null){
                this.draw_attribution_gate(this.props.lineOverlay);
            }
        }
    }

    draw_source_rect(){
        if(this.canvas !== null){
            let source_viewport_desired_height = this.source_viewport.height;
            let source_viewport_desired_width = this.source_viewport.width;
            let source_viewport_y = this.source_viewport.y;
            let source_viewport_x = this.source_viewport.x;

            if(this.canvas.clientHeight > this.canvas.clientWidth){
                //View is portrait
                const aspect_ratio = this.canvas.clientHeight / this.canvas.clientWidth;
                source_viewport_desired_height = aspect_ratio * this.source_viewport.width;
                source_viewport_y = this.source_viewport.y - (source_viewport_desired_height-this.source_viewport.height)/2;

            } else {
                //view is landscape
                const aspect_ratio = this.canvas.clientWidth / this.canvas.clientHeight;
                source_viewport_desired_width = aspect_ratio * this.source_viewport.height;
                source_viewport_x = this.source_viewport.x - (source_viewport_desired_width-this.source_viewport.width)/2;
            }

            //var inv_item = this.investigation_list.investigations.get(this.inv_shown);
            if(this.props.source_rect.rect != null){
                var xscale = source_viewport_desired_width / this.canvas.width;
                var yscale = source_viewport_desired_height/ this.canvas.height;
                var rect_color = 'black'; //Default attribution box color
                if(this.props.source_rect.color != null){
                    rect_color = this.props.source_rect.color;
                }
                const context = this.canvas.getContext('2d');
                if (context === null)
                    return;
                context.strokeStyle = rect_color;
                context.globalAlpha = 0.5;
                context.lineWidth = 3;
                context.strokeRect((this.props.source_rect.rect.left- source_viewport_x)/xscale,
                               (this.props.source_rect.rect.up-source_viewport_y)/yscale,
                               (this.props.source_rect.rect.right-this.props.source_rect.rect.left)/xscale,
                               (this.props.source_rect.rect.down-this.props.source_rect.rect.up)/yscale);

                context.fillStyle = rect_color;
                context.globalAlpha = 0.1;
                context.fillRect((this.props.source_rect.rect.left- source_viewport_x)/xscale,
                              (this.props.source_rect.rect.up-source_viewport_y)/yscale,
                              (this.props.source_rect.rect.right-this.props.source_rect.rect.left)/xscale,
                              (this.props.source_rect.rect.down-this.props.source_rect.rect.up)/yscale);
            }
        }
    }

    draw_attribution_gate(lineOverlay: ImagePoint[]){
        if(this.canvas !== null && lineOverlay !== undefined && lineOverlay !== null){
            let source_viewport_desired_height = this.source_viewport.height;
            let source_viewport_desired_width = this.source_viewport.width;
            let source_viewport_y = this.source_viewport.y;
            let source_viewport_x = this.source_viewport.x;

            if(this.canvas.clientHeight > this.canvas.clientWidth){
                //View is portrait
                const aspect_ratio = this.canvas.clientHeight / this.canvas.clientWidth;
                source_viewport_desired_height = aspect_ratio * this.source_viewport.width;
                source_viewport_y = this.source_viewport.y - (source_viewport_desired_height-this.source_viewport.height)/2;

            } else {
                //view is landscape
                const aspect_ratio = this.canvas.clientWidth / this.canvas.clientHeight;
                source_viewport_desired_width = aspect_ratio * this.source_viewport.height;
                source_viewport_x = this.source_viewport.x - (source_viewport_desired_width-this.source_viewport.width)/2;
            }

            //if(this.props.source_rect.rect != null){
                var xscale = source_viewport_desired_width / this.canvas.width;
                var yscale = source_viewport_desired_height/ this.canvas.height;
                var rect_color = 'red'; //Default attribution box color
                const context = this.canvas.getContext('2d');
                if (context === null)
                    return;
                context.strokeStyle = rect_color;
                context.globalAlpha = 0.5;
                context.lineWidth = 3;
                context.beginPath();
                lineOverlay.forEach((point,idx) => {
                    if(idx === 0){
                        context.moveTo((point.x-source_viewport_x)/xscale,(point.y-source_viewport_y)/yscale);
                    } else {
                        context.lineTo((point.x-source_viewport_x)/xscale,(point.y-source_viewport_y)/yscale);
                    }
                });
                context.stroke();
        }
    }

    render(){
        return (
            <>
            {this.getPopout()}
            <div ref={this.canvasContainerRef} style={{display: 'flex', flex:1, width:'98%', height:'98%', alignItems:'center', justifyContent:'center'}} >
                 <canvas ref={this.canvasRef} className="image-canvas" height="98%" width="98%" style={{objectFit:'contain'}}></canvas>
            </div>
            </>
        );
    }
}
export default AttributionImageDisplay

//******************************************************************************
//Popout window for High Resolution Attribution Image display

interface PopoutAttributionImageDisplayProps {
    title: string;                          // The title of the popout window
    image: HTMLImageElement|null;
    source_rect:SourceRect;
    closeWindow: () => void;                // Callback to close the popout
    lineOverlay?: ImagePoint[];
}

interface PopoutAttributionImageDisplayState {
    externalWindow: Window | null;          // The popout window
    containerElement: HTMLElement | null;   // The root element of the popout window
}

export class PopoutAttributionImageDisplay extends React.Component<PopoutAttributionImageDisplayProps, PopoutAttributionImageDisplayState> {
    close_popout_timer:NodeJS.Timeout | null = null;

    constructor(props: PopoutAttributionImageDisplayProps) {
        super(props);
        this.state = {
            externalWindow: null,
            containerElement: null
        };
        this.resize = this.resize.bind(this)

}

    // When we create this component, open a new window
    public componentDidMount() {
        const features = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600, height=700, left=300, top=200';
        const externalWindow = window.open('', '', features);

        let containerElement = null;
        if (externalWindow) {
            containerElement = externalWindow.document.createElement('div');
            externalWindow.document.body.appendChild(containerElement);

            externalWindow.document.title = this.props.title;


            // Unload method did not close the external window. This closes the window reliably
            this.close_popout_timer = setInterval(()=> {
                if(externalWindow.closed) {
                    if(this.close_popout_timer){
                        clearInterval(this.close_popout_timer);
                        this.close_popout_timer = null;
                    }
                    this.props.closeWindow();
                    if(this.state.externalWindow)
                        this.state.externalWindow.close();
                }
            }, 1000);
        }

        this.setState({
            externalWindow: externalWindow,
            containerElement: containerElement
        });

        if(externalWindow !== null)
            externalWindow.addEventListener("resize", this.resize);
    }

    // Make sure the window closes when the component unmounts
    public componentWillUnmount() {
        if(this.close_popout_timer){
            clearInterval(this.close_popout_timer);
            this.close_popout_timer = null;
        }
        if (this.state.externalWindow) {
            this.state.externalWindow.close();
        }
    }

    resize(){
        this.render();
    }

    public render() {
        if (!this.state.containerElement) {
            return null;
        }

        const context = <AttributionImageDisplay image={this.props.image} source_rect={this.props.source_rect} window={this.state.externalWindow}
                                                 enablePanZoom={true} lineOverlay={this.props.lineOverlay}/>

        // Render this component's children into the root element of the popout window
        return ReactDOM.createPortal(context, this.state.containerElement);
    }
}



//******************************************************************************
